import { render, staticRenderFns } from "./CallActions.vue?vue&type=template&id=10c3d141&scoped=true&"
import script from "./CallActions.vue?vue&type=script&lang=js&"
export * from "./CallActions.vue?vue&type=script&lang=js&"
import style0 from "./CallActions.vue?vue&type=style&index=0&id=10c3d141&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c3d141",
  null
  
)

export default component.exports